<template>
    <div class="sidebar">
      <div></div>
        <!-- <div class="glitch" data-text="WELCOME">WELCOME</div>  -->
        <div class="sidebar__list">
            <div class="glitch list last"></div> 
            <a href="#bye"><div class="glitch list" data-text="Contact">Contact</div></a>
            <a href="#technologies"><div class="glitch list" data-text="Technologies">Technologies</div></a> 
            <a href="#projects"><div class="glitch list" data-text="Projects">Projects</div></a> 
            <a href="#work"><div class="glitch list" data-text="Work">Work</div> </a>
            <!-- <a href="#education"><div class="glitch list" data-text="Education">Education</div></a>  -->
            <a href="#home"><div class="glitch list" data-text="Home">Home</div> </a>
            <div class="glitch list first"></div> 
    </div>
    </div>
</template>
  
  
<script>
export default {
    name: "Navbar",
    data() {
        return {
            show: false,
        };
    },
};
</script>
  
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=La+Belle+Aurore&display=swap');

.sidebar {
    height: 100vh;
    position:absolute;
    width: clamp(300px,20vw, 300px);
    z-index: 2;
    top:0;
    &__list {
        height: 100vh;
        position: relative;
        display: flex;
        gap:clamp(5px,1vh,15px);
        flex-direction: column-reverse;
        padding: clamp(40px, 5vw, 100px);
    }
}
a {
  text-decoration: none;
  color: inherit;
}
.last:after {
    content: '</list>';
    font-family: 'La Belle Aurore', cursive;
    color: #515152;
    font-size: clamp(20px, 1.6vw, 40px);
    position: absolute;top:-1.5vh;
    left:clamp(-20px, -1.5vw, -5px);
}
.first:before {
    content: '<list>';
    font-family: 'La Belle Aurore', cursive;
    color: #515152;
    font-size: clamp(20px, 1.6vw, 40px);
    position: absolute;
    top:-3vh;
    left:clamp(-20px, -1.5vw, -5px);
}

.navbar__menu__contact.active {
    display: none;
}
@media screen and (max-width: 500px) {
.sidebar__list {
    padding-bottom: 10vh;
}
}
</style>